function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#b58e3b"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M60 49.114a5 5 0 01-2.5 4.329l-25 14.444a5 5 0 01-5 0l-25-14.444A5 5 0 010 49.114v-28.9a5 5 0 012.5-4.329l25-14.44a5 5 0 015 0l25 14.445a5 5 0 012.5 4.329z"
}),
/*#__PURE__*/
React.createElement("path", {
  d: "M55 20.219L30 5.775 5 20.219v28.895L30 63.56l25-14.445V20.22m5 0v28.895a5 5 0 01-2.499 4.33l-25 14.444a5 5 0 01-5.002 0l-25-14.444A5 5 0 010 49.114V20.22a5 5 0 012.499-4.33l25-14.444a5 5 0 015.002 0l25 14.445A5 5 0 0160 20.219z",
  fill: "rgba(255,255,255,.21)"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M28.841 50a1.707 1.707 0 01-1.217-.5L17.452 39.335a1.724 1.724 0 010-2.435l13.462-13.043a3.474 3.474 0 012.194-.9h9.187a1.724 1.724 0 011.722 1.721v9.178a3.459 3.459 0 01-.914 2.2L30.066 49.493a1.714 1.714 0 01-1.225.507zm4.267-25.573a2.023 2.023 0 00-1.16.479L18.487 37.951a.249.249 0 00.008.341l10.172 10.159a.249.249 0 00.348 0l13.039-13.438a2.042 2.042 0 00.488-1.166v-9.178a.249.249 0 00-.247-.246z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fff",
  d: "M16.23 36.8a.735.735 0 01-.521-.215l-.206-.2a1.724 1.724 0 010-2.436l13.462-13.043a3.472 3.472 0 012.193-.9h9.187a1.724 1.724 0 011.722 1.721.738.738 0 01-1.475 0 .25.25 0 00-.247-.246h-9.187a2.061 2.061 0 00-1.16.479l-13.46 13.042a.248.248 0 00.008.341l.2.2a.738.738 0 01-.521 1.261zm22.866-6.473a2.459 2.459 0 112.461-2.459 2.463 2.463 0 01-2.461 2.459zm0-3.443a.984.984 0 10.986.984.986.986 0 00-.986-.983z"
});

var SvgAchievementFullPrice = function SvgAchievementFullPrice(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      viewBox: "0 0 60 70",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgAchievementFullPrice, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/AchievementFullPrice.43d51d96.svg";
export { ForwardRef as ReactComponent };